import React from "react";
import { default as moment } from "moment";

import { IDataFragment } from "core/components/FragmentProvider";
import Label from "core/components/label/Label";
import styled from "styled-components";
import { TextInputView } from "common/views/textInput/TextInput.view";
import { ICESelfReportFragmetProps } from "./CESelfReportForm.panel";
import RichTextWidgdet from "common/form/widgets/richText/RichTextWidget";
import Query from "core/api/QueryComponent";
import { CreditType } from "panels/subscriptions/entities/CreditEntry";
import { stateToHTML } from "draft-js-export-html";
import { ContentState, convertFromRaw } from "draft-js";
import TypographyView from "common/views/typographyView/Typography.view";

const StyledDiv = styled.div`
	 {
		display: flex;
		justify-content: flex-start;
		padding: 0.5em;
		width: 50%;
		flex-flow: column wrap;
		margin-bottom: 12px
		& > input {
			height:40px;
		}
		// text-align: center;
		// & > span {
		// 	flex: 2;
		// }
		// & > div {
		// 	flex: 1;
		// }
	}
`;

export const name: IDataFragment<ICESelfReportFragmetProps> = {
	name: "name",
	label: {},
	component: ({ onChange, entry }) => {
		return (
			<React.Fragment>
				<StyledDiv>
				<TypographyView viewKey="name.title"  >
					<Label k="Label.CE.name" v="Name" />
				</TypographyView>
					<TextInputView
						viewKey="CE.name"
						placeholder="Name"
						value={entry.name}
						onChange={(value: string) => onChange("name", value)}
					/>
				</StyledDiv>
			</React.Fragment>
		);
	}
};

export const startDate: IDataFragment<ICESelfReportFragmetProps> = {
	name: "startDate",
	label: {},
	component: ({ onChange, entry }) => {
		let attr = {};
		attr["max"] = (() => {
			let d = new Date();
			d.setFullYear(d.getFullYear() + 5);
			return moment(d).format("YYYY-MM-DD");
		})();

		return (
			<React.Fragment>
				<StyledDiv>
					<TypographyView viewKey="startDate.title" >
						<Label k={"startDate"} v={"Start Date"} />
					</TypographyView>
					<TextInputView
						viewKey="CE.startDate"
						type="date"
						placeholder="Start Date"
						value={entry.startDate}
						onChange={(value: string) =>
							onChange("startDate", value)
						}
						htmlAttributes={attr}
					/>
				</StyledDiv>
			</React.Fragment>
		);
	}
};

export const endDate: IDataFragment<ICESelfReportFragmetProps> = {
	name: "endDate",
	label: {},
	component: ({ onChange, entry }) => {
		let attr = {};

		if (!entry["startDate"]) attr["disabled"] = true;
		else {
			attr["max"] = (() => {
				let d = new Date();
				d.setFullYear(d.getFullYear() + 5);
				return moment(d).format("YYYY-MM-DD");
			})();

			attr["min"] = (() => {
				let d = entry["startDate"];
				return moment(d).format("YYYY-MM-DD");
			})();
		}

		return (
			<React.Fragment>
				<StyledDiv>
				<TypographyView viewKey="endDate.title"  >
					<Label k={"endDate"} v={"End Date"} />
				</TypographyView>
					<TextInputView
						viewKey="CE.endDate"
						type="date"
						placeholder="End Date"
						value={entry.endDate}
						onChange={(value: string) => onChange("endDate", value)}
						htmlAttributes={attr}
					/>
				</StyledDiv>
			</React.Fragment>
		);
	}
};

export const creditYear: IDataFragment<ICESelfReportFragmetProps> = {
	name: "Creadit Year",
	label: {},
	component: ({ onChange, entry }) => {
		let attr = {};
		attr["max"] = 1900;
		attr["max"] = 2099;
		attr["step"] = 1;

		return (
			<React.Fragment>
				<StyledDiv>
					<TypographyView viewKey="credityear.title"  >
						<Label k={"credityear"} v={"Credit year"} />
					</TypographyView>
					<TextInputView
						viewKey="CE.credityear"
						type="number"
						placeholder="Credit Year"
						value={entry.year}
						onChange={(value: string) => onChange("year", value)}
						htmlAttributes={attr}
					/>
				</StyledDiv>
			</React.Fragment>
		);
	}
};

export const description: IDataFragment<ICESelfReportFragmetProps> = {
	name: "description",
	label: {},
	component: ({ onChange, entry }) => {
		return (
			<React.Fragment>
				<StyledDiv style={{width:"100%"}}>
					<TypographyView viewKey="description.title"  >
						<Label k="Label.CE.description" v="Description" />
					</TypographyView>
					<RichTextWidgdet
						value={entry.description}
						onChange={data => {
							let raw = convertFromRaw(JSON.parse(data));
							onChange("description", stateToHTML(raw));
						}}
						/>
				</StyledDiv>
			</React.Fragment>
		);
	}
};

export const credits: IDataFragment<ICESelfReportFragmetProps> = {
    name: "Credits",
    label: {},
    component: ({ onChange, entry, config }) => {
        let attr = {};
        attr["step"] = config.creditStep || 1;
        return (
        <Query.Many entity={CreditType} args={{ id: 0 }}>
            {({ data, forceRefresh }) => {
                const credits = [];
                data &&
                    data.map(credit => {
                        credits.push(
                            <StyledDiv>
                                <TypographyView viewKey="credits.title" >
                                    <Label
                                        k={`Label.CE.${credit.name}`}
                                        v={credit.name}
                                    />
                                </TypographyView>  
                                <TextInputView
                                    viewKey={`CE.${credit.name}`}
                                    type="number"
                                    placeholder={credit.name}
                                    value={entry[credit.name]}
                                    htmlAttributes={attr}
                                    onChange={value =>{
                                        let key = credit.id;
                                        let credits= {...entry.credits}
                                        credits[key]= {
                                            id: credit.id,
                                            name: credit.name,
                                            value: value,
                                        }
 
                                        onChange("credits", credits);
                                    }
                                    }
                                />
                            </StyledDiv>
                        );
                    });
                return <React.Fragment>{credits}</React.Fragment>;
            }}
        </Query.Many>
        )
    }
};

export const uploadCertificate: IDataFragment<ICESelfReportFragmetProps> = {
	name: "Upload Certificate",
	label: {},
	component: ({ onChange, entry }) => {
		return (
			<React.Fragment>
				<StyledDiv>
					<TypographyView viewKey="upload.certificate.title" >
						<Label
							k="Label.CE.uploadCertificate"
							v="Upload Certificate"
						/>
					</TypographyView>
					<TextInputView
						viewKey="CE.uploadCertificate"
						type="file"
						placeholder="uploadCertificate"
						value={entry.uploadCertificate}
						onChange={value => {
							onChange("certificate", value[0]);
						}}
					/>
				</StyledDiv>
			</React.Fragment>
		);
	}
};



// WEBPACK FOOTER //
// ./src/panels/addExternalCredit/displayFragments.tsx